import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6954c750 = () => interopDefault(import('../themes/novaporta/pages/index.vue' /* webpackChunkName: "themes/novaporta/pages/index" */))
const _50f53882 = () => interopDefault(import('../themes/novaporta/pages/index/components/MainSlider/index.vue' /* webpackChunkName: "themes/novaporta/pages/index/components/MainSlider/index" */))
const _5005ba2e = () => interopDefault(import('../themes/novaporta/pages/index/components/MainSlider/types.js' /* webpackChunkName: "themes/novaporta/pages/index/components/MainSlider/types" */))
const _0d3a3d3e = () => interopDefault(import('../themes/novaporta/pages/404.vue' /* webpackChunkName: "themes/novaporta/pages/404" */))
const _6eece454 = () => interopDefault(import('../themes/novaporta/pages/about/index.vue' /* webpackChunkName: "themes/novaporta/pages/about/index" */))
const _5560a2ea = () => interopDefault(import('../themes/novaporta/pages/articles/index.vue' /* webpackChunkName: "themes/novaporta/pages/articles/index" */))
const _733d476b = () => interopDefault(import('../themes/novaporta/pages/career/index.vue' /* webpackChunkName: "themes/novaporta/pages/career/index" */))
const _506c850d = () => interopDefault(import('../themes/novaporta/pages/cart/index.vue' /* webpackChunkName: "themes/novaporta/pages/cart/index" */))
const _66c9e500 = () => interopDefault(import('../themes/novaporta/pages/contacts/index.vue' /* webpackChunkName: "themes/novaporta/pages/contacts/index" */))
const _2b83a250 = () => interopDefault(import('../themes/novaporta/pages/cookies/index.vue' /* webpackChunkName: "themes/novaporta/pages/cookies/index" */))
const _c5ad183e = () => interopDefault(import('../themes/novaporta/pages/delivery/index.vue' /* webpackChunkName: "themes/novaporta/pages/delivery/index" */))
const _707ff920 = () => interopDefault(import('../themes/novaporta/pages/favorites/index.vue' /* webpackChunkName: "themes/novaporta/pages/favorites/index" */))
const _435c541f = () => interopDefault(import('../themes/novaporta/pages/policy/index.vue' /* webpackChunkName: "themes/novaporta/pages/policy/index" */))
const _5836c85b = () => interopDefault(import('../themes/novaporta/pages/product_list/index.vue' /* webpackChunkName: "themes/novaporta/pages/product_list/index" */))
const _3c31aec5 = () => interopDefault(import('../themes/novaporta/pages/review/index.vue' /* webpackChunkName: "themes/novaporta/pages/review/index" */))
const _7e7622d8 = () => interopDefault(import('../themes/novaporta/pages/special-offers/index.vue' /* webpackChunkName: "themes/novaporta/pages/special-offers/index" */))
const _12830350 = () => interopDefault(import('../themes/novaporta/pages/terms/index.vue' /* webpackChunkName: "themes/novaporta/pages/terms/index" */))
const _15367219 = () => interopDefault(import('../themes/novaporta/pages/ui-kit-demo.vue' /* webpackChunkName: "themes/novaporta/pages/ui-kit-demo" */))
const _114fd9f2 = () => interopDefault(import('../themes/novaporta/pages/about/types.js' /* webpackChunkName: "themes/novaporta/pages/about/types" */))
const _ed105b44 = () => interopDefault(import('../themes/novaporta/pages/articles/types.js' /* webpackChunkName: "themes/novaporta/pages/articles/types" */))
const _612419bd = () => interopDefault(import('../themes/novaporta/pages/career/types.js' /* webpackChunkName: "themes/novaporta/pages/career/types" */))
const _37b4c04a = () => interopDefault(import('../themes/novaporta/pages/cart/types.js' /* webpackChunkName: "themes/novaporta/pages/cart/types" */))
const _0134f2f2 = () => interopDefault(import('../themes/novaporta/pages/delivery/types.js' /* webpackChunkName: "themes/novaporta/pages/delivery/types" */))
const _6a8f41ba = () => interopDefault(import('../themes/novaporta/pages/review/types.js' /* webpackChunkName: "themes/novaporta/pages/review/types" */))
const _5cacac50 = () => interopDefault(import('../themes/novaporta/pages/about/components/AchievementMessage/index.vue' /* webpackChunkName: "themes/novaporta/pages/about/components/AchievementMessage/index" */))
const _181cf228 = () => interopDefault(import('../themes/novaporta/pages/about/components/Gallery/index.vue' /* webpackChunkName: "themes/novaporta/pages/about/components/Gallery/index" */))
const _05aa8c76 = () => interopDefault(import('../themes/novaporta/pages/about/components/HangAchievements/index.vue' /* webpackChunkName: "themes/novaporta/pages/about/components/HangAchievements/index" */))
const _533cabbb = () => interopDefault(import('../themes/novaporta/pages/about/components/MediaInfoBlock/index.vue' /* webpackChunkName: "themes/novaporta/pages/about/components/MediaInfoBlock/index" */))
const _3d778aa2 = () => interopDefault(import('../themes/novaporta/pages/articles/components/ItemsLarge/index.vue' /* webpackChunkName: "themes/novaporta/pages/articles/components/ItemsLarge/index" */))
const _4eaf457b = () => interopDefault(import('../themes/novaporta/pages/articles/components/ItemsSmall/index.vue' /* webpackChunkName: "themes/novaporta/pages/articles/components/ItemsSmall/index" */))
const _2ed61a20 = () => interopDefault(import('../themes/novaporta/pages/articles/components/MySkeletonNews/index.vue' /* webpackChunkName: "themes/novaporta/pages/articles/components/MySkeletonNews/index" */))
const _1eaccd83 = () => interopDefault(import('../themes/novaporta/pages/career/components/ModalSendResume/index.vue' /* webpackChunkName: "themes/novaporta/pages/career/components/ModalSendResume/index" */))
const _2a82003a = () => interopDefault(import('../themes/novaporta/pages/career/components/ModalVacancy/index.vue' /* webpackChunkName: "themes/novaporta/pages/career/components/ModalVacancy/index" */))
const _47c5fa10 = () => interopDefault(import('../themes/novaporta/pages/career/components/VacanciesList/index.vue' /* webpackChunkName: "themes/novaporta/pages/career/components/VacanciesList/index" */))
const _7e57979b = () => interopDefault(import('../themes/novaporta/pages/cart/components/CartProducts/index.vue' /* webpackChunkName: "themes/novaporta/pages/cart/components/CartProducts/index" */))
const _4a7a264e = () => interopDefault(import('../themes/novaporta/pages/cart/components/Credits/index.vue' /* webpackChunkName: "themes/novaporta/pages/cart/components/Credits/index" */))
const _3d8407bb = () => interopDefault(import('../themes/novaporta/pages/cart/components/Form/index.vue' /* webpackChunkName: "themes/novaporta/pages/cart/components/Form/index" */))
const _60466c0e = () => interopDefault(import('../themes/novaporta/pages/delivery/components/Info/index.vue' /* webpackChunkName: "themes/novaporta/pages/delivery/components/Info/index" */))
const _c6ed566e = () => interopDefault(import('../themes/novaporta/pages/delivery/components/Tabs/index.vue' /* webpackChunkName: "themes/novaporta/pages/delivery/components/Tabs/index" */))
const _aa31b662 = () => interopDefault(import('../themes/novaporta/pages/review/components/VideoReviews/index.vue' /* webpackChunkName: "themes/novaporta/pages/review/components/VideoReviews/index" */))
const _71bcf41d = () => interopDefault(import('../themes/novaporta/pages/special-offers/components/ItemsLarge/index.vue' /* webpackChunkName: "themes/novaporta/pages/special-offers/components/ItemsLarge/index" */))
const _01cee16a = () => interopDefault(import('../themes/novaporta/pages/articles/_url/index.vue' /* webpackChunkName: "themes/novaporta/pages/articles/_url/index" */))
const _2f0a4806 = () => interopDefault(import('../themes/novaporta/pages/order-checkout/_id/index.vue' /* webpackChunkName: "themes/novaporta/pages/order-checkout/_id/index" */))
const _342c27bd = () => interopDefault(import('../themes/novaporta/pages/product/_product/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/index" */))
const _ee8857c6 = () => interopDefault(import('../themes/novaporta/pages/special-offers/_url/index.vue' /* webpackChunkName: "themes/novaporta/pages/special-offers/_url/index" */))
const _0ad055dd = () => interopDefault(import('../themes/novaporta/pages/articles/_url/types.js' /* webpackChunkName: "themes/novaporta/pages/articles/_url/types" */))
const _2d8ee72b = () => interopDefault(import('../themes/novaporta/pages/product/_product/types.js' /* webpackChunkName: "themes/novaporta/pages/product/_product/types" */))
const _a7afa26a = () => interopDefault(import('../themes/novaporta/pages/special-offers/_url/types.js' /* webpackChunkName: "themes/novaporta/pages/special-offers/_url/types" */))
const _889bf03e = () => interopDefault(import('../themes/novaporta/pages/articles/_url/components/Banner/index.vue' /* webpackChunkName: "themes/novaporta/pages/articles/_url/components/Banner/index" */))
const _2eb502fa = () => interopDefault(import('../themes/novaporta/pages/articles/_url/components/Content/index.vue' /* webpackChunkName: "themes/novaporta/pages/articles/_url/components/Content/index" */))
const _fb348c08 = () => interopDefault(import('../themes/novaporta/pages/articles/_url/components/Video/index.vue' /* webpackChunkName: "themes/novaporta/pages/articles/_url/components/Video/index" */))
const _7ada4847 = () => interopDefault(import('../themes/novaporta/pages/product/_product/components/Characteristics/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/components/Characteristics/index" */))
const _6d5561ea = () => interopDefault(import('../themes/novaporta/pages/product/_product/components/Description/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/components/Description/index" */))
const _573dac24 = () => interopDefault(import('../themes/novaporta/pages/product/_product/components/InfoCards/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/components/InfoCards/index" */))
const _013878d6 = () => interopDefault(import('../themes/novaporta/pages/product/_product/components/ModalAddedToCart/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/components/ModalAddedToCart/index" */))
const _0aa34676 = () => interopDefault(import('../themes/novaporta/pages/product/_product/components/ModalPocketProducts/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/components/ModalPocketProducts/index" */))
const _e6024384 = () => interopDefault(import('../themes/novaporta/pages/product/_product/components/Product/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/components/Product/index" */))
const _7826d7b0 = () => interopDefault(import('../themes/novaporta/pages/product/_product/components/StalkingPanel/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/components/StalkingPanel/index" */))
const _07c0d0a5 = () => interopDefault(import('../themes/novaporta/pages/product/_product/components/Tabs/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/components/Tabs/index" */))
const _3a507c33 = () => interopDefault(import('../themes/novaporta/pages/special-offers/_url/components/Banner/index.vue' /* webpackChunkName: "themes/novaporta/pages/special-offers/_url/components/Banner/index" */))
const _f835ce30 = () => interopDefault(import('../themes/novaporta/pages/special-offers/_url/components/Content/index.vue' /* webpackChunkName: "themes/novaporta/pages/special-offers/_url/components/Content/index" */))
const _12de736a = () => interopDefault(import('../themes/novaporta/pages/special-offers/_url/components/Video/index.vue' /* webpackChunkName: "themes/novaporta/pages/special-offers/_url/components/Video/index" */))
const _3ae47de2 = () => interopDefault(import('../themes/novaporta/pages/special-offers/_url/modular/CategoryProducts/index.vue' /* webpackChunkName: "themes/novaporta/pages/special-offers/_url/modular/CategoryProducts/index" */))
const _d04060e4 = () => interopDefault(import('../themes/novaporta/pages/articles/_url/components/Banner/skeleton.vue' /* webpackChunkName: "themes/novaporta/pages/articles/_url/components/Banner/skeleton" */))
const _c07b5c56 = () => interopDefault(import('../themes/novaporta/pages/articles/_url/components/Content/skeleton.vue' /* webpackChunkName: "themes/novaporta/pages/articles/_url/components/Content/skeleton" */))
const _7d79b8da = () => interopDefault(import('../themes/novaporta/pages/articles/_url/components/Video/skeleton.vue' /* webpackChunkName: "themes/novaporta/pages/articles/_url/components/Video/skeleton" */))
const _616221fc = () => interopDefault(import('../themes/novaporta/pages/special-offers/_url/components/Banner/skeleton.vue' /* webpackChunkName: "themes/novaporta/pages/special-offers/_url/components/Banner/skeleton" */))
const _068a4d27 = () => interopDefault(import('../themes/novaporta/pages/special-offers/_url/components/Content/skeleton.vue' /* webpackChunkName: "themes/novaporta/pages/special-offers/_url/components/Content/skeleton" */))
const _1215cb65 = () => interopDefault(import('../themes/novaporta/pages/special-offers/_url/components/Video/skeleton.vue' /* webpackChunkName: "themes/novaporta/pages/special-offers/_url/components/Video/skeleton" */))
const _b26848ce = () => interopDefault(import('../themes/novaporta/pages/special-offers/_url/modular/CategoryProducts/types.js' /* webpackChunkName: "themes/novaporta/pages/special-offers/_url/modular/CategoryProducts/types" */))
const _6cdfdb8e = () => interopDefault(import('../themes/novaporta/pages/product/_product/components/ModalPocketProducts/components/FilterPriceInput/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/components/ModalPocketProducts/components/FilterPriceInput/index" */))
const _2bd53a1e = () => interopDefault(import('../themes/novaporta/pages/product/_product/components/ModalPocketProducts/components/Filters/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/components/ModalPocketProducts/components/Filters/index" */))
const _9ca75f30 = () => interopDefault(import('../themes/novaporta/pages/product/_product/components/Product/components/ButtonInfo/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/components/Product/components/ButtonInfo/index" */))
const _402fe62a = () => interopDefault(import('../themes/novaporta/pages/product/_product/components/Product/components/PanelBoard/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/components/Product/components/PanelBoard/index" */))
const _fcf24b56 = () => interopDefault(import('../themes/novaporta/pages/product/_product/components/Product/components/ScreenSlider/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/components/Product/components/ScreenSlider/index" */))
const _1b45bb89 = () => interopDefault(import('../themes/novaporta/pages/product/_product/components/Product/components/Slider/index.vue' /* webpackChunkName: "themes/novaporta/pages/product/_product/components/Product/components/Slider/index" */))
const _7bc1c55c = () => interopDefault(import('../themes/novaporta/pages/special-offers/_url/modular/CategoryProducts/components/FilterPriceInput/index.vue' /* webpackChunkName: "themes/novaporta/pages/special-offers/_url/modular/CategoryProducts/components/FilterPriceInput/index" */))
const _35e557cc = () => interopDefault(import('../themes/novaporta/pages/special-offers/_url/modular/CategoryProducts/components/FiltersSidebar/index.vue' /* webpackChunkName: "themes/novaporta/pages/special-offers/_url/modular/CategoryProducts/components/FiltersSidebar/index" */))
const _6ef4d507 = () => interopDefault(import('../themes/novaporta/pages/special-offers/_url/modular/CategoryProducts/components/ModalFilters/index.vue' /* webpackChunkName: "themes/novaporta/pages/special-offers/_url/modular/CategoryProducts/components/ModalFilters/index" */))
const _ac2d3044 = () => interopDefault(import('../themes/novaporta/pages/special-offers/_url/modular/CategoryProducts/mixins/filters.js' /* webpackChunkName: "themes/novaporta/pages/special-offers/_url/modular/CategoryProducts/mixins/filters" */))
const _97dfe736 = () => interopDefault(import('../themes/novaporta/pages/_.vue' /* webpackChunkName: "themes/novaporta/pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  scrollBehavior,

  routes: [{
    path: "/en",
    component: _6954c750,
    pathToRegexpOptions: {"strict":true},
    name: "index___en",
    children: [{
      path: "components/MainSlider",
      component: _50f53882,
      pathToRegexpOptions: {"strict":true},
      name: "index-components-MainSlider___en"
    }, {
      path: "components/MainSlider/types",
      component: _5005ba2e,
      pathToRegexpOptions: {"strict":true},
      name: "index-components-MainSlider-types___en"
    }]
  }, {
    path: "/ro",
    component: _6954c750,
    pathToRegexpOptions: {"strict":true},
    name: "index___ro",
    children: [{
      path: "components/MainSlider",
      component: _50f53882,
      pathToRegexpOptions: {"strict":true},
      name: "index-components-MainSlider___ro"
    }, {
      path: "components/MainSlider/types",
      component: _5005ba2e,
      pathToRegexpOptions: {"strict":true},
      name: "index-components-MainSlider-types___ro"
    }]
  }, {
    path: "/ru",
    component: _6954c750,
    pathToRegexpOptions: {"strict":true},
    name: "index___ru",
    children: [{
      path: "components/MainSlider",
      component: _50f53882,
      pathToRegexpOptions: {"strict":true},
      name: "index-components-MainSlider___ru"
    }, {
      path: "components/MainSlider/types",
      component: _5005ba2e,
      pathToRegexpOptions: {"strict":true},
      name: "index-components-MainSlider-types___ru"
    }]
  }, {
    path: "/uk",
    component: _6954c750,
    pathToRegexpOptions: {"strict":true},
    name: "index___uk",
    children: [{
      path: "components/MainSlider",
      component: _50f53882,
      pathToRegexpOptions: {"strict":true},
      name: "index-components-MainSlider___uk"
    }, {
      path: "components/MainSlider/types",
      component: _5005ba2e,
      pathToRegexpOptions: {"strict":true},
      name: "index-components-MainSlider-types___uk"
    }]
  }, {
    path: "/en/404",
    component: _0d3a3d3e,
    pathToRegexpOptions: {"strict":true},
    name: "404___en"
  }, {
    path: "/en/about",
    component: _6eece454,
    pathToRegexpOptions: {"strict":true},
    name: "about___en"
  }, {
    path: "/en/articles",
    component: _5560a2ea,
    pathToRegexpOptions: {"strict":true},
    name: "articles___en"
  }, {
    path: "/en/career",
    component: _733d476b,
    pathToRegexpOptions: {"strict":true},
    name: "career___en"
  }, {
    path: "/en/cart",
    component: _506c850d,
    pathToRegexpOptions: {"strict":true},
    name: "cart___en"
  }, {
    path: "/en/contacts",
    component: _66c9e500,
    pathToRegexpOptions: {"strict":true},
    name: "contacts___en"
  }, {
    path: "/en/cookies",
    component: _2b83a250,
    pathToRegexpOptions: {"strict":true},
    name: "cookies___en"
  }, {
    path: "/en/delivery",
    component: _c5ad183e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery___en"
  }, {
    path: "/en/favorites",
    component: _707ff920,
    pathToRegexpOptions: {"strict":true},
    name: "favorites___en"
  }, {
    path: "/en/policy",
    component: _435c541f,
    pathToRegexpOptions: {"strict":true},
    name: "policy___en"
  }, {
    path: "/en/product_list",
    component: _5836c85b,
    pathToRegexpOptions: {"strict":true},
    name: "product_list___en"
  }, {
    path: "/en/review",
    component: _3c31aec5,
    pathToRegexpOptions: {"strict":true},
    name: "review___en"
  }, {
    path: "/en/special-offers",
    component: _7e7622d8,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers___en"
  }, {
    path: "/en/terms",
    component: _12830350,
    pathToRegexpOptions: {"strict":true},
    name: "terms___en"
  }, {
    path: "/en/ui-kit-demo",
    component: _15367219,
    pathToRegexpOptions: {"strict":true},
    name: "ui-kit-demo___en"
  }, {
    path: "/ro/404",
    component: _0d3a3d3e,
    pathToRegexpOptions: {"strict":true},
    name: "404___ro"
  }, {
    path: "/ro/about",
    component: _6eece454,
    pathToRegexpOptions: {"strict":true},
    name: "about___ro"
  }, {
    path: "/ro/articles",
    component: _5560a2ea,
    pathToRegexpOptions: {"strict":true},
    name: "articles___ro"
  }, {
    path: "/ro/career",
    component: _733d476b,
    pathToRegexpOptions: {"strict":true},
    name: "career___ro"
  }, {
    path: "/ro/cart",
    component: _506c850d,
    pathToRegexpOptions: {"strict":true},
    name: "cart___ro"
  }, {
    path: "/ro/contacts",
    component: _66c9e500,
    pathToRegexpOptions: {"strict":true},
    name: "contacts___ro"
  }, {
    path: "/ro/cookies",
    component: _2b83a250,
    pathToRegexpOptions: {"strict":true},
    name: "cookies___ro"
  }, {
    path: "/ro/delivery",
    component: _c5ad183e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery___ro"
  }, {
    path: "/ro/favorites",
    component: _707ff920,
    pathToRegexpOptions: {"strict":true},
    name: "favorites___ro"
  }, {
    path: "/ro/policy",
    component: _435c541f,
    pathToRegexpOptions: {"strict":true},
    name: "policy___ro"
  }, {
    path: "/ro/product_list",
    component: _5836c85b,
    pathToRegexpOptions: {"strict":true},
    name: "product_list___ro"
  }, {
    path: "/ro/review",
    component: _3c31aec5,
    pathToRegexpOptions: {"strict":true},
    name: "review___ro"
  }, {
    path: "/ro/special-offers",
    component: _7e7622d8,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers___ro"
  }, {
    path: "/ro/terms",
    component: _12830350,
    pathToRegexpOptions: {"strict":true},
    name: "terms___ro"
  }, {
    path: "/ro/ui-kit-demo",
    component: _15367219,
    pathToRegexpOptions: {"strict":true},
    name: "ui-kit-demo___ro"
  }, {
    path: "/ru/404",
    component: _0d3a3d3e,
    pathToRegexpOptions: {"strict":true},
    name: "404___ru"
  }, {
    path: "/ru/about",
    component: _6eece454,
    pathToRegexpOptions: {"strict":true},
    name: "about___ru"
  }, {
    path: "/ru/articles",
    component: _5560a2ea,
    pathToRegexpOptions: {"strict":true},
    name: "articles___ru"
  }, {
    path: "/ru/career",
    component: _733d476b,
    pathToRegexpOptions: {"strict":true},
    name: "career___ru"
  }, {
    path: "/ru/cart",
    component: _506c850d,
    pathToRegexpOptions: {"strict":true},
    name: "cart___ru"
  }, {
    path: "/ru/contacts",
    component: _66c9e500,
    pathToRegexpOptions: {"strict":true},
    name: "contacts___ru"
  }, {
    path: "/ru/cookies",
    component: _2b83a250,
    pathToRegexpOptions: {"strict":true},
    name: "cookies___ru"
  }, {
    path: "/ru/delivery",
    component: _c5ad183e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery___ru"
  }, {
    path: "/ru/favorites",
    component: _707ff920,
    pathToRegexpOptions: {"strict":true},
    name: "favorites___ru"
  }, {
    path: "/ru/policy",
    component: _435c541f,
    pathToRegexpOptions: {"strict":true},
    name: "policy___ru"
  }, {
    path: "/ru/product_list",
    component: _5836c85b,
    pathToRegexpOptions: {"strict":true},
    name: "product_list___ru"
  }, {
    path: "/ru/review",
    component: _3c31aec5,
    pathToRegexpOptions: {"strict":true},
    name: "review___ru"
  }, {
    path: "/ru/special-offers",
    component: _7e7622d8,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers___ru"
  }, {
    path: "/ru/terms",
    component: _12830350,
    pathToRegexpOptions: {"strict":true},
    name: "terms___ru"
  }, {
    path: "/ru/ui-kit-demo",
    component: _15367219,
    pathToRegexpOptions: {"strict":true},
    name: "ui-kit-demo___ru"
  }, {
    path: "/uk/404",
    component: _0d3a3d3e,
    pathToRegexpOptions: {"strict":true},
    name: "404___uk"
  }, {
    path: "/uk/about",
    component: _6eece454,
    pathToRegexpOptions: {"strict":true},
    name: "about___uk"
  }, {
    path: "/uk/articles",
    component: _5560a2ea,
    pathToRegexpOptions: {"strict":true},
    name: "articles___uk"
  }, {
    path: "/uk/career",
    component: _733d476b,
    pathToRegexpOptions: {"strict":true},
    name: "career___uk"
  }, {
    path: "/uk/cart",
    component: _506c850d,
    pathToRegexpOptions: {"strict":true},
    name: "cart___uk"
  }, {
    path: "/uk/contacts",
    component: _66c9e500,
    pathToRegexpOptions: {"strict":true},
    name: "contacts___uk"
  }, {
    path: "/uk/cookies",
    component: _2b83a250,
    pathToRegexpOptions: {"strict":true},
    name: "cookies___uk"
  }, {
    path: "/uk/delivery",
    component: _c5ad183e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery___uk"
  }, {
    path: "/uk/favorites",
    component: _707ff920,
    pathToRegexpOptions: {"strict":true},
    name: "favorites___uk"
  }, {
    path: "/uk/policy",
    component: _435c541f,
    pathToRegexpOptions: {"strict":true},
    name: "policy___uk"
  }, {
    path: "/uk/product_list",
    component: _5836c85b,
    pathToRegexpOptions: {"strict":true},
    name: "product_list___uk"
  }, {
    path: "/uk/review",
    component: _3c31aec5,
    pathToRegexpOptions: {"strict":true},
    name: "review___uk"
  }, {
    path: "/uk/special-offers",
    component: _7e7622d8,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers___uk"
  }, {
    path: "/uk/terms",
    component: _12830350,
    pathToRegexpOptions: {"strict":true},
    name: "terms___uk"
  }, {
    path: "/uk/ui-kit-demo",
    component: _15367219,
    pathToRegexpOptions: {"strict":true},
    name: "ui-kit-demo___uk"
  }, {
    path: "/en/about/types",
    component: _114fd9f2,
    pathToRegexpOptions: {"strict":true},
    name: "about-types___en"
  }, {
    path: "/en/articles/types",
    component: _ed105b44,
    pathToRegexpOptions: {"strict":true},
    name: "articles-types___en"
  }, {
    path: "/en/career/types",
    component: _612419bd,
    pathToRegexpOptions: {"strict":true},
    name: "career-types___en"
  }, {
    path: "/en/cart/types",
    component: _37b4c04a,
    pathToRegexpOptions: {"strict":true},
    name: "cart-types___en"
  }, {
    path: "/en/delivery/types",
    component: _0134f2f2,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-types___en"
  }, {
    path: "/en/review/types",
    component: _6a8f41ba,
    pathToRegexpOptions: {"strict":true},
    name: "review-types___en"
  }, {
    path: "/ro/about/types",
    component: _114fd9f2,
    pathToRegexpOptions: {"strict":true},
    name: "about-types___ro"
  }, {
    path: "/ro/articles/types",
    component: _ed105b44,
    pathToRegexpOptions: {"strict":true},
    name: "articles-types___ro"
  }, {
    path: "/ro/career/types",
    component: _612419bd,
    pathToRegexpOptions: {"strict":true},
    name: "career-types___ro"
  }, {
    path: "/ro/cart/types",
    component: _37b4c04a,
    pathToRegexpOptions: {"strict":true},
    name: "cart-types___ro"
  }, {
    path: "/ro/delivery/types",
    component: _0134f2f2,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-types___ro"
  }, {
    path: "/ro/review/types",
    component: _6a8f41ba,
    pathToRegexpOptions: {"strict":true},
    name: "review-types___ro"
  }, {
    path: "/ru/about/types",
    component: _114fd9f2,
    pathToRegexpOptions: {"strict":true},
    name: "about-types___ru"
  }, {
    path: "/ru/articles/types",
    component: _ed105b44,
    pathToRegexpOptions: {"strict":true},
    name: "articles-types___ru"
  }, {
    path: "/ru/career/types",
    component: _612419bd,
    pathToRegexpOptions: {"strict":true},
    name: "career-types___ru"
  }, {
    path: "/ru/cart/types",
    component: _37b4c04a,
    pathToRegexpOptions: {"strict":true},
    name: "cart-types___ru"
  }, {
    path: "/ru/delivery/types",
    component: _0134f2f2,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-types___ru"
  }, {
    path: "/ru/review/types",
    component: _6a8f41ba,
    pathToRegexpOptions: {"strict":true},
    name: "review-types___ru"
  }, {
    path: "/uk/about/types",
    component: _114fd9f2,
    pathToRegexpOptions: {"strict":true},
    name: "about-types___uk"
  }, {
    path: "/uk/articles/types",
    component: _ed105b44,
    pathToRegexpOptions: {"strict":true},
    name: "articles-types___uk"
  }, {
    path: "/uk/career/types",
    component: _612419bd,
    pathToRegexpOptions: {"strict":true},
    name: "career-types___uk"
  }, {
    path: "/uk/cart/types",
    component: _37b4c04a,
    pathToRegexpOptions: {"strict":true},
    name: "cart-types___uk"
  }, {
    path: "/uk/delivery/types",
    component: _0134f2f2,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-types___uk"
  }, {
    path: "/uk/review/types",
    component: _6a8f41ba,
    pathToRegexpOptions: {"strict":true},
    name: "review-types___uk"
  }, {
    path: "/en/about/components/AchievementMessage",
    component: _5cacac50,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-AchievementMessage___en"
  }, {
    path: "/en/about/components/Gallery",
    component: _181cf228,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-Gallery___en"
  }, {
    path: "/en/about/components/HangAchievements",
    component: _05aa8c76,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-HangAchievements___en"
  }, {
    path: "/en/about/components/MediaInfoBlock",
    component: _533cabbb,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-MediaInfoBlock___en"
  }, {
    path: "/en/articles/components/ItemsLarge",
    component: _3d778aa2,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsLarge___en"
  }, {
    path: "/en/articles/components/ItemsSmall",
    component: _4eaf457b,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsSmall___en"
  }, {
    path: "/en/articles/components/MySkeletonNews",
    component: _2ed61a20,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-MySkeletonNews___en"
  }, {
    path: "/en/career/components/ModalSendResume",
    component: _1eaccd83,
    pathToRegexpOptions: {"strict":true},
    name: "career-components-ModalSendResume___en"
  }, {
    path: "/en/career/components/ModalVacancy",
    component: _2a82003a,
    pathToRegexpOptions: {"strict":true},
    name: "career-components-ModalVacancy___en"
  }, {
    path: "/en/career/components/VacanciesList",
    component: _47c5fa10,
    pathToRegexpOptions: {"strict":true},
    name: "career-components-VacanciesList___en"
  }, {
    path: "/en/cart/components/CartProducts",
    component: _7e57979b,
    pathToRegexpOptions: {"strict":true},
    name: "cart-components-CartProducts___en"
  }, {
    path: "/en/cart/components/Credits",
    component: _4a7a264e,
    pathToRegexpOptions: {"strict":true},
    name: "cart-components-Credits___en"
  }, {
    path: "/en/cart/components/Form",
    component: _3d8407bb,
    pathToRegexpOptions: {"strict":true},
    name: "cart-components-Form___en"
  }, {
    path: "/en/delivery/components/Info",
    component: _60466c0e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-components-Info___en"
  }, {
    path: "/en/delivery/components/Tabs",
    component: _c6ed566e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-components-Tabs___en"
  }, {
    path: "/en/review/components/VideoReviews",
    component: _aa31b662,
    pathToRegexpOptions: {"strict":true},
    name: "review-components-VideoReviews___en"
  }, {
    path: "/en/special-offers/components/ItemsLarge",
    component: _71bcf41d,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-components-ItemsLarge___en"
  }, {
    path: "/ro/about/components/AchievementMessage",
    component: _5cacac50,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-AchievementMessage___ro"
  }, {
    path: "/ro/about/components/Gallery",
    component: _181cf228,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-Gallery___ro"
  }, {
    path: "/ro/about/components/HangAchievements",
    component: _05aa8c76,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-HangAchievements___ro"
  }, {
    path: "/ro/about/components/MediaInfoBlock",
    component: _533cabbb,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-MediaInfoBlock___ro"
  }, {
    path: "/ro/articles/components/ItemsLarge",
    component: _3d778aa2,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsLarge___ro"
  }, {
    path: "/ro/articles/components/ItemsSmall",
    component: _4eaf457b,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsSmall___ro"
  }, {
    path: "/ro/articles/components/MySkeletonNews",
    component: _2ed61a20,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-MySkeletonNews___ro"
  }, {
    path: "/ro/career/components/ModalSendResume",
    component: _1eaccd83,
    pathToRegexpOptions: {"strict":true},
    name: "career-components-ModalSendResume___ro"
  }, {
    path: "/ro/career/components/ModalVacancy",
    component: _2a82003a,
    pathToRegexpOptions: {"strict":true},
    name: "career-components-ModalVacancy___ro"
  }, {
    path: "/ro/career/components/VacanciesList",
    component: _47c5fa10,
    pathToRegexpOptions: {"strict":true},
    name: "career-components-VacanciesList___ro"
  }, {
    path: "/ro/cart/components/CartProducts",
    component: _7e57979b,
    pathToRegexpOptions: {"strict":true},
    name: "cart-components-CartProducts___ro"
  }, {
    path: "/ro/cart/components/Credits",
    component: _4a7a264e,
    pathToRegexpOptions: {"strict":true},
    name: "cart-components-Credits___ro"
  }, {
    path: "/ro/cart/components/Form",
    component: _3d8407bb,
    pathToRegexpOptions: {"strict":true},
    name: "cart-components-Form___ro"
  }, {
    path: "/ro/delivery/components/Info",
    component: _60466c0e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-components-Info___ro"
  }, {
    path: "/ro/delivery/components/Tabs",
    component: _c6ed566e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-components-Tabs___ro"
  }, {
    path: "/ro/review/components/VideoReviews",
    component: _aa31b662,
    pathToRegexpOptions: {"strict":true},
    name: "review-components-VideoReviews___ro"
  }, {
    path: "/ro/special-offers/components/ItemsLarge",
    component: _71bcf41d,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-components-ItemsLarge___ro"
  }, {
    path: "/ru/about/components/AchievementMessage",
    component: _5cacac50,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-AchievementMessage___ru"
  }, {
    path: "/ru/about/components/Gallery",
    component: _181cf228,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-Gallery___ru"
  }, {
    path: "/ru/about/components/HangAchievements",
    component: _05aa8c76,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-HangAchievements___ru"
  }, {
    path: "/ru/about/components/MediaInfoBlock",
    component: _533cabbb,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-MediaInfoBlock___ru"
  }, {
    path: "/ru/articles/components/ItemsLarge",
    component: _3d778aa2,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsLarge___ru"
  }, {
    path: "/ru/articles/components/ItemsSmall",
    component: _4eaf457b,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsSmall___ru"
  }, {
    path: "/ru/articles/components/MySkeletonNews",
    component: _2ed61a20,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-MySkeletonNews___ru"
  }, {
    path: "/ru/career/components/ModalSendResume",
    component: _1eaccd83,
    pathToRegexpOptions: {"strict":true},
    name: "career-components-ModalSendResume___ru"
  }, {
    path: "/ru/career/components/ModalVacancy",
    component: _2a82003a,
    pathToRegexpOptions: {"strict":true},
    name: "career-components-ModalVacancy___ru"
  }, {
    path: "/ru/career/components/VacanciesList",
    component: _47c5fa10,
    pathToRegexpOptions: {"strict":true},
    name: "career-components-VacanciesList___ru"
  }, {
    path: "/ru/cart/components/CartProducts",
    component: _7e57979b,
    pathToRegexpOptions: {"strict":true},
    name: "cart-components-CartProducts___ru"
  }, {
    path: "/ru/cart/components/Credits",
    component: _4a7a264e,
    pathToRegexpOptions: {"strict":true},
    name: "cart-components-Credits___ru"
  }, {
    path: "/ru/cart/components/Form",
    component: _3d8407bb,
    pathToRegexpOptions: {"strict":true},
    name: "cart-components-Form___ru"
  }, {
    path: "/ru/delivery/components/Info",
    component: _60466c0e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-components-Info___ru"
  }, {
    path: "/ru/delivery/components/Tabs",
    component: _c6ed566e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-components-Tabs___ru"
  }, {
    path: "/ru/review/components/VideoReviews",
    component: _aa31b662,
    pathToRegexpOptions: {"strict":true},
    name: "review-components-VideoReviews___ru"
  }, {
    path: "/ru/special-offers/components/ItemsLarge",
    component: _71bcf41d,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-components-ItemsLarge___ru"
  }, {
    path: "/uk/about/components/AchievementMessage",
    component: _5cacac50,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-AchievementMessage___uk"
  }, {
    path: "/uk/about/components/Gallery",
    component: _181cf228,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-Gallery___uk"
  }, {
    path: "/uk/about/components/HangAchievements",
    component: _05aa8c76,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-HangAchievements___uk"
  }, {
    path: "/uk/about/components/MediaInfoBlock",
    component: _533cabbb,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-MediaInfoBlock___uk"
  }, {
    path: "/uk/articles/components/ItemsLarge",
    component: _3d778aa2,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsLarge___uk"
  }, {
    path: "/uk/articles/components/ItemsSmall",
    component: _4eaf457b,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsSmall___uk"
  }, {
    path: "/uk/articles/components/MySkeletonNews",
    component: _2ed61a20,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-MySkeletonNews___uk"
  }, {
    path: "/uk/career/components/ModalSendResume",
    component: _1eaccd83,
    pathToRegexpOptions: {"strict":true},
    name: "career-components-ModalSendResume___uk"
  }, {
    path: "/uk/career/components/ModalVacancy",
    component: _2a82003a,
    pathToRegexpOptions: {"strict":true},
    name: "career-components-ModalVacancy___uk"
  }, {
    path: "/uk/career/components/VacanciesList",
    component: _47c5fa10,
    pathToRegexpOptions: {"strict":true},
    name: "career-components-VacanciesList___uk"
  }, {
    path: "/uk/cart/components/CartProducts",
    component: _7e57979b,
    pathToRegexpOptions: {"strict":true},
    name: "cart-components-CartProducts___uk"
  }, {
    path: "/uk/cart/components/Credits",
    component: _4a7a264e,
    pathToRegexpOptions: {"strict":true},
    name: "cart-components-Credits___uk"
  }, {
    path: "/uk/cart/components/Form",
    component: _3d8407bb,
    pathToRegexpOptions: {"strict":true},
    name: "cart-components-Form___uk"
  }, {
    path: "/uk/delivery/components/Info",
    component: _60466c0e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-components-Info___uk"
  }, {
    path: "/uk/delivery/components/Tabs",
    component: _c6ed566e,
    pathToRegexpOptions: {"strict":true},
    name: "delivery-components-Tabs___uk"
  }, {
    path: "/uk/review/components/VideoReviews",
    component: _aa31b662,
    pathToRegexpOptions: {"strict":true},
    name: "review-components-VideoReviews___uk"
  }, {
    path: "/uk/special-offers/components/ItemsLarge",
    component: _71bcf41d,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-components-ItemsLarge___uk"
  }, {
    path: "/en/articles/:url",
    component: _01cee16a,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url___en"
  }, {
    path: "/en/order-checkout/:id",
    component: _2f0a4806,
    pathToRegexpOptions: {"strict":true},
    name: "order-checkout-id___en"
  }, {
    path: "/en/product/:product",
    component: _342c27bd,
    pathToRegexpOptions: {"strict":true},
    name: "product-product___en"
  }, {
    path: "/en/special-offers/:url",
    component: _ee8857c6,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url___en"
  }, {
    path: "/ro/articles/:url",
    component: _01cee16a,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url___ro"
  }, {
    path: "/ro/order-checkout/:id",
    component: _2f0a4806,
    pathToRegexpOptions: {"strict":true},
    name: "order-checkout-id___ro"
  }, {
    path: "/ro/product/:product",
    component: _342c27bd,
    pathToRegexpOptions: {"strict":true},
    name: "product-product___ro"
  }, {
    path: "/ro/special-offers/:url",
    component: _ee8857c6,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url___ro"
  }, {
    path: "/ru/articles/:url",
    component: _01cee16a,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url___ru"
  }, {
    path: "/ru/order-checkout/:id",
    component: _2f0a4806,
    pathToRegexpOptions: {"strict":true},
    name: "order-checkout-id___ru"
  }, {
    path: "/ru/product/:product",
    component: _342c27bd,
    pathToRegexpOptions: {"strict":true},
    name: "product-product___ru"
  }, {
    path: "/ru/special-offers/:url",
    component: _ee8857c6,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url___ru"
  }, {
    path: "/uk/articles/:url",
    component: _01cee16a,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url___uk"
  }, {
    path: "/uk/order-checkout/:id",
    component: _2f0a4806,
    pathToRegexpOptions: {"strict":true},
    name: "order-checkout-id___uk"
  }, {
    path: "/uk/product/:product",
    component: _342c27bd,
    pathToRegexpOptions: {"strict":true},
    name: "product-product___uk"
  }, {
    path: "/uk/special-offers/:url",
    component: _ee8857c6,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url___uk"
  }, {
    path: "/en/articles/:url/types",
    component: _0ad055dd,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-types___en"
  }, {
    path: "/en/product/:product?/types",
    component: _2d8ee72b,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-types___en"
  }, {
    path: "/en/special-offers/:url?/types",
    component: _a7afa26a,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-types___en"
  }, {
    path: "/ro/articles/:url/types",
    component: _0ad055dd,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-types___ro"
  }, {
    path: "/ro/product/:product?/types",
    component: _2d8ee72b,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-types___ro"
  }, {
    path: "/ro/special-offers/:url?/types",
    component: _a7afa26a,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-types___ro"
  }, {
    path: "/ru/articles/:url/types",
    component: _0ad055dd,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-types___ru"
  }, {
    path: "/ru/product/:product?/types",
    component: _2d8ee72b,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-types___ru"
  }, {
    path: "/ru/special-offers/:url?/types",
    component: _a7afa26a,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-types___ru"
  }, {
    path: "/uk/articles/:url/types",
    component: _0ad055dd,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-types___uk"
  }, {
    path: "/uk/product/:product?/types",
    component: _2d8ee72b,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-types___uk"
  }, {
    path: "/uk/special-offers/:url?/types",
    component: _a7afa26a,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-types___uk"
  }, {
    path: "/en/articles/:url/components/Banner",
    component: _889bf03e,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner___en"
  }, {
    path: "/en/articles/:url/components/Content",
    component: _2eb502fa,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content___en"
  }, {
    path: "/en/articles/:url/components/Video",
    component: _fb348c08,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video___en"
  }, {
    path: "/en/product/:product?/components/Characteristics",
    component: _7ada4847,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Characteristics___en"
  }, {
    path: "/en/product/:product?/components/Description",
    component: _6d5561ea,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Description___en"
  }, {
    path: "/en/product/:product?/components/InfoCards",
    component: _573dac24,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-InfoCards___en"
  }, {
    path: "/en/product/:product?/components/ModalAddedToCart",
    component: _013878d6,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalAddedToCart___en"
  }, {
    path: "/en/product/:product?/components/ModalPocketProducts",
    component: _0aa34676,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalPocketProducts___en"
  }, {
    path: "/en/product/:product?/components/Product",
    component: _e6024384,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product___en"
  }, {
    path: "/en/product/:product?/components/StalkingPanel",
    component: _7826d7b0,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-StalkingPanel___en"
  }, {
    path: "/en/product/:product?/components/Tabs",
    component: _07c0d0a5,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Tabs___en"
  }, {
    path: "/en/special-offers/:url?/components/Banner",
    component: _3a507c33,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Banner___en"
  }, {
    path: "/en/special-offers/:url?/components/Content",
    component: _f835ce30,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Content___en"
  }, {
    path: "/en/special-offers/:url?/components/Video",
    component: _12de736a,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Video___en"
  }, {
    path: "/en/special-offers/:url?/modular/CategoryProducts",
    component: _3ae47de2,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts___en"
  }, {
    path: "/ro/articles/:url/components/Banner",
    component: _889bf03e,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner___ro"
  }, {
    path: "/ro/articles/:url/components/Content",
    component: _2eb502fa,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content___ro"
  }, {
    path: "/ro/articles/:url/components/Video",
    component: _fb348c08,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video___ro"
  }, {
    path: "/ro/product/:product?/components/Characteristics",
    component: _7ada4847,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Characteristics___ro"
  }, {
    path: "/ro/product/:product?/components/Description",
    component: _6d5561ea,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Description___ro"
  }, {
    path: "/ro/product/:product?/components/InfoCards",
    component: _573dac24,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-InfoCards___ro"
  }, {
    path: "/ro/product/:product?/components/ModalAddedToCart",
    component: _013878d6,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalAddedToCart___ro"
  }, {
    path: "/ro/product/:product?/components/ModalPocketProducts",
    component: _0aa34676,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalPocketProducts___ro"
  }, {
    path: "/ro/product/:product?/components/Product",
    component: _e6024384,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product___ro"
  }, {
    path: "/ro/product/:product?/components/StalkingPanel",
    component: _7826d7b0,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-StalkingPanel___ro"
  }, {
    path: "/ro/product/:product?/components/Tabs",
    component: _07c0d0a5,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Tabs___ro"
  }, {
    path: "/ro/special-offers/:url?/components/Banner",
    component: _3a507c33,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Banner___ro"
  }, {
    path: "/ro/special-offers/:url?/components/Content",
    component: _f835ce30,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Content___ro"
  }, {
    path: "/ro/special-offers/:url?/components/Video",
    component: _12de736a,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Video___ro"
  }, {
    path: "/ro/special-offers/:url?/modular/CategoryProducts",
    component: _3ae47de2,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts___ro"
  }, {
    path: "/ru/articles/:url/components/Banner",
    component: _889bf03e,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner___ru"
  }, {
    path: "/ru/articles/:url/components/Content",
    component: _2eb502fa,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content___ru"
  }, {
    path: "/ru/articles/:url/components/Video",
    component: _fb348c08,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video___ru"
  }, {
    path: "/ru/product/:product?/components/Characteristics",
    component: _7ada4847,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Characteristics___ru"
  }, {
    path: "/ru/product/:product?/components/Description",
    component: _6d5561ea,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Description___ru"
  }, {
    path: "/ru/product/:product?/components/InfoCards",
    component: _573dac24,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-InfoCards___ru"
  }, {
    path: "/ru/product/:product?/components/ModalAddedToCart",
    component: _013878d6,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalAddedToCart___ru"
  }, {
    path: "/ru/product/:product?/components/ModalPocketProducts",
    component: _0aa34676,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalPocketProducts___ru"
  }, {
    path: "/ru/product/:product?/components/Product",
    component: _e6024384,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product___ru"
  }, {
    path: "/ru/product/:product?/components/StalkingPanel",
    component: _7826d7b0,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-StalkingPanel___ru"
  }, {
    path: "/ru/product/:product?/components/Tabs",
    component: _07c0d0a5,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Tabs___ru"
  }, {
    path: "/ru/special-offers/:url?/components/Banner",
    component: _3a507c33,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Banner___ru"
  }, {
    path: "/ru/special-offers/:url?/components/Content",
    component: _f835ce30,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Content___ru"
  }, {
    path: "/ru/special-offers/:url?/components/Video",
    component: _12de736a,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Video___ru"
  }, {
    path: "/ru/special-offers/:url?/modular/CategoryProducts",
    component: _3ae47de2,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts___ru"
  }, {
    path: "/uk/articles/:url/components/Banner",
    component: _889bf03e,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner___uk"
  }, {
    path: "/uk/articles/:url/components/Content",
    component: _2eb502fa,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content___uk"
  }, {
    path: "/uk/articles/:url/components/Video",
    component: _fb348c08,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video___uk"
  }, {
    path: "/uk/product/:product?/components/Characteristics",
    component: _7ada4847,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Characteristics___uk"
  }, {
    path: "/uk/product/:product?/components/Description",
    component: _6d5561ea,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Description___uk"
  }, {
    path: "/uk/product/:product?/components/InfoCards",
    component: _573dac24,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-InfoCards___uk"
  }, {
    path: "/uk/product/:product?/components/ModalAddedToCart",
    component: _013878d6,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalAddedToCart___uk"
  }, {
    path: "/uk/product/:product?/components/ModalPocketProducts",
    component: _0aa34676,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalPocketProducts___uk"
  }, {
    path: "/uk/product/:product?/components/Product",
    component: _e6024384,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product___uk"
  }, {
    path: "/uk/product/:product?/components/StalkingPanel",
    component: _7826d7b0,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-StalkingPanel___uk"
  }, {
    path: "/uk/product/:product?/components/Tabs",
    component: _07c0d0a5,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Tabs___uk"
  }, {
    path: "/uk/special-offers/:url?/components/Banner",
    component: _3a507c33,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Banner___uk"
  }, {
    path: "/uk/special-offers/:url?/components/Content",
    component: _f835ce30,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Content___uk"
  }, {
    path: "/uk/special-offers/:url?/components/Video",
    component: _12de736a,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Video___uk"
  }, {
    path: "/uk/special-offers/:url?/modular/CategoryProducts",
    component: _3ae47de2,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts___uk"
  }, {
    path: "/en/articles/:url/components/Banner/skeleton",
    component: _d04060e4,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner-skeleton___en"
  }, {
    path: "/en/articles/:url/components/Content/skeleton",
    component: _c07b5c56,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content-skeleton___en"
  }, {
    path: "/en/articles/:url/components/Video/skeleton",
    component: _7d79b8da,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video-skeleton___en"
  }, {
    path: "/en/special-offers/:url?/components/Banner/skeleton",
    component: _616221fc,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Banner-skeleton___en"
  }, {
    path: "/en/special-offers/:url?/components/Content/skeleton",
    component: _068a4d27,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Content-skeleton___en"
  }, {
    path: "/en/special-offers/:url?/components/Video/skeleton",
    component: _1215cb65,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Video-skeleton___en"
  }, {
    path: "/en/special-offers/:url?/modular/CategoryProducts/types",
    component: _b26848ce,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-types___en"
  }, {
    path: "/ro/articles/:url/components/Banner/skeleton",
    component: _d04060e4,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner-skeleton___ro"
  }, {
    path: "/ro/articles/:url/components/Content/skeleton",
    component: _c07b5c56,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content-skeleton___ro"
  }, {
    path: "/ro/articles/:url/components/Video/skeleton",
    component: _7d79b8da,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video-skeleton___ro"
  }, {
    path: "/ro/special-offers/:url?/components/Banner/skeleton",
    component: _616221fc,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Banner-skeleton___ro"
  }, {
    path: "/ro/special-offers/:url?/components/Content/skeleton",
    component: _068a4d27,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Content-skeleton___ro"
  }, {
    path: "/ro/special-offers/:url?/components/Video/skeleton",
    component: _1215cb65,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Video-skeleton___ro"
  }, {
    path: "/ro/special-offers/:url?/modular/CategoryProducts/types",
    component: _b26848ce,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-types___ro"
  }, {
    path: "/ru/articles/:url/components/Banner/skeleton",
    component: _d04060e4,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner-skeleton___ru"
  }, {
    path: "/ru/articles/:url/components/Content/skeleton",
    component: _c07b5c56,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content-skeleton___ru"
  }, {
    path: "/ru/articles/:url/components/Video/skeleton",
    component: _7d79b8da,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video-skeleton___ru"
  }, {
    path: "/ru/special-offers/:url?/components/Banner/skeleton",
    component: _616221fc,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Banner-skeleton___ru"
  }, {
    path: "/ru/special-offers/:url?/components/Content/skeleton",
    component: _068a4d27,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Content-skeleton___ru"
  }, {
    path: "/ru/special-offers/:url?/components/Video/skeleton",
    component: _1215cb65,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Video-skeleton___ru"
  }, {
    path: "/ru/special-offers/:url?/modular/CategoryProducts/types",
    component: _b26848ce,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-types___ru"
  }, {
    path: "/uk/articles/:url/components/Banner/skeleton",
    component: _d04060e4,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner-skeleton___uk"
  }, {
    path: "/uk/articles/:url/components/Content/skeleton",
    component: _c07b5c56,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content-skeleton___uk"
  }, {
    path: "/uk/articles/:url/components/Video/skeleton",
    component: _7d79b8da,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video-skeleton___uk"
  }, {
    path: "/uk/special-offers/:url?/components/Banner/skeleton",
    component: _616221fc,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Banner-skeleton___uk"
  }, {
    path: "/uk/special-offers/:url?/components/Content/skeleton",
    component: _068a4d27,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Content-skeleton___uk"
  }, {
    path: "/uk/special-offers/:url?/components/Video/skeleton",
    component: _1215cb65,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-components-Video-skeleton___uk"
  }, {
    path: "/uk/special-offers/:url?/modular/CategoryProducts/types",
    component: _b26848ce,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-types___uk"
  }, {
    path: "/en/product/:product?/components/ModalPocketProducts/components/FilterPriceInput",
    component: _6cdfdb8e,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalPocketProducts-components-FilterPriceInput___en"
  }, {
    path: "/en/product/:product?/components/ModalPocketProducts/components/Filters",
    component: _2bd53a1e,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalPocketProducts-components-Filters___en"
  }, {
    path: "/en/product/:product?/components/Product/components/ButtonInfo",
    component: _9ca75f30,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-ButtonInfo___en"
  }, {
    path: "/en/product/:product?/components/Product/components/PanelBoard",
    component: _402fe62a,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-PanelBoard___en"
  }, {
    path: "/en/product/:product?/components/Product/components/ScreenSlider",
    component: _fcf24b56,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-ScreenSlider___en"
  }, {
    path: "/en/product/:product?/components/Product/components/Slider",
    component: _1b45bb89,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-Slider___en"
  }, {
    path: "/en/special-offers/:url?/modular/CategoryProducts/components/FilterPriceInput",
    component: _7bc1c55c,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-components-FilterPriceInput___en"
  }, {
    path: "/en/special-offers/:url?/modular/CategoryProducts/components/FiltersSidebar",
    component: _35e557cc,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-components-FiltersSidebar___en"
  }, {
    path: "/en/special-offers/:url?/modular/CategoryProducts/components/ModalFilters",
    component: _6ef4d507,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-components-ModalFilters___en"
  }, {
    path: "/en/special-offers/:url?/modular/CategoryProducts/mixins/filters",
    component: _ac2d3044,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-mixins-filters___en"
  }, {
    path: "/ro/product/:product?/components/ModalPocketProducts/components/FilterPriceInput",
    component: _6cdfdb8e,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalPocketProducts-components-FilterPriceInput___ro"
  }, {
    path: "/ro/product/:product?/components/ModalPocketProducts/components/Filters",
    component: _2bd53a1e,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalPocketProducts-components-Filters___ro"
  }, {
    path: "/ro/product/:product?/components/Product/components/ButtonInfo",
    component: _9ca75f30,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-ButtonInfo___ro"
  }, {
    path: "/ro/product/:product?/components/Product/components/PanelBoard",
    component: _402fe62a,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-PanelBoard___ro"
  }, {
    path: "/ro/product/:product?/components/Product/components/ScreenSlider",
    component: _fcf24b56,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-ScreenSlider___ro"
  }, {
    path: "/ro/product/:product?/components/Product/components/Slider",
    component: _1b45bb89,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-Slider___ro"
  }, {
    path: "/ro/special-offers/:url?/modular/CategoryProducts/components/FilterPriceInput",
    component: _7bc1c55c,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-components-FilterPriceInput___ro"
  }, {
    path: "/ro/special-offers/:url?/modular/CategoryProducts/components/FiltersSidebar",
    component: _35e557cc,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-components-FiltersSidebar___ro"
  }, {
    path: "/ro/special-offers/:url?/modular/CategoryProducts/components/ModalFilters",
    component: _6ef4d507,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-components-ModalFilters___ro"
  }, {
    path: "/ro/special-offers/:url?/modular/CategoryProducts/mixins/filters",
    component: _ac2d3044,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-mixins-filters___ro"
  }, {
    path: "/ru/product/:product?/components/ModalPocketProducts/components/FilterPriceInput",
    component: _6cdfdb8e,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalPocketProducts-components-FilterPriceInput___ru"
  }, {
    path: "/ru/product/:product?/components/ModalPocketProducts/components/Filters",
    component: _2bd53a1e,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalPocketProducts-components-Filters___ru"
  }, {
    path: "/ru/product/:product?/components/Product/components/ButtonInfo",
    component: _9ca75f30,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-ButtonInfo___ru"
  }, {
    path: "/ru/product/:product?/components/Product/components/PanelBoard",
    component: _402fe62a,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-PanelBoard___ru"
  }, {
    path: "/ru/product/:product?/components/Product/components/ScreenSlider",
    component: _fcf24b56,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-ScreenSlider___ru"
  }, {
    path: "/ru/product/:product?/components/Product/components/Slider",
    component: _1b45bb89,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-Slider___ru"
  }, {
    path: "/ru/special-offers/:url?/modular/CategoryProducts/components/FilterPriceInput",
    component: _7bc1c55c,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-components-FilterPriceInput___ru"
  }, {
    path: "/ru/special-offers/:url?/modular/CategoryProducts/components/FiltersSidebar",
    component: _35e557cc,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-components-FiltersSidebar___ru"
  }, {
    path: "/ru/special-offers/:url?/modular/CategoryProducts/components/ModalFilters",
    component: _6ef4d507,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-components-ModalFilters___ru"
  }, {
    path: "/ru/special-offers/:url?/modular/CategoryProducts/mixins/filters",
    component: _ac2d3044,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-mixins-filters___ru"
  }, {
    path: "/uk/product/:product?/components/ModalPocketProducts/components/FilterPriceInput",
    component: _6cdfdb8e,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalPocketProducts-components-FilterPriceInput___uk"
  }, {
    path: "/uk/product/:product?/components/ModalPocketProducts/components/Filters",
    component: _2bd53a1e,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-ModalPocketProducts-components-Filters___uk"
  }, {
    path: "/uk/product/:product?/components/Product/components/ButtonInfo",
    component: _9ca75f30,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-ButtonInfo___uk"
  }, {
    path: "/uk/product/:product?/components/Product/components/PanelBoard",
    component: _402fe62a,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-PanelBoard___uk"
  }, {
    path: "/uk/product/:product?/components/Product/components/ScreenSlider",
    component: _fcf24b56,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-ScreenSlider___uk"
  }, {
    path: "/uk/product/:product?/components/Product/components/Slider",
    component: _1b45bb89,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-Slider___uk"
  }, {
    path: "/uk/special-offers/:url?/modular/CategoryProducts/components/FilterPriceInput",
    component: _7bc1c55c,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-components-FilterPriceInput___uk"
  }, {
    path: "/uk/special-offers/:url?/modular/CategoryProducts/components/FiltersSidebar",
    component: _35e557cc,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-components-FiltersSidebar___uk"
  }, {
    path: "/uk/special-offers/:url?/modular/CategoryProducts/components/ModalFilters",
    component: _6ef4d507,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-components-ModalFilters___uk"
  }, {
    path: "/uk/special-offers/:url?/modular/CategoryProducts/mixins/filters",
    component: _ac2d3044,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-url-modular-CategoryProducts-mixins-filters___uk"
  }, {
    path: "/en/*",
    component: _97dfe736,
    pathToRegexpOptions: {"strict":true},
    name: "all___en"
  }, {
    path: "/uk/*",
    component: _97dfe736,
    pathToRegexpOptions: {"strict":true},
    name: "all___uk"
  }, {
    path: "/ru/*",
    component: _97dfe736,
    pathToRegexpOptions: {"strict":true},
    name: "all___ru"
  }, {
    path: "/ro/*",
    component: _97dfe736,
    pathToRegexpOptions: {"strict":true},
    name: "all___ro"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
